import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AdmissionStatusEnum } from "src/app/shared/enum";
import { EnquiryInterface, onClose, PaymentMethodEnum } from "src/app/shared/interfaces";
import { ChangeAdmissionStatus, PostScheduleInterviewInterface } from "../interfaces";

export const adminAdmissionActions = createActionGroup({
    source: "admin-admission",
    events: {
        "schedule interview": props<{
            data: PostScheduleInterviewInterface;
            onClose: onClose;
        }>(),
        "schedule bulk interviews": props<{
            data: PostScheduleInterviewInterface;
            onClose: onClose;
        }>(),
        "change admission status": props<{
            data: ChangeAdmissionStatus;
            onClose: onClose;
        }>(),
        "update enquiry": props<{
            data: EnquiryInterface;
            id: string;
            onClose: onClose;
        }>(),
        "send admission mail": props<{ id: string; email: string }>(),
        "export admission excel": props<{ status?: AdmissionStatusEnum }>(),
        "export enquiries excel": emptyProps(),
        "export idcard excel": emptyProps(),
        "receive seprate payment": props<{
            data: {
                instalment_id: string;
                amount: number;
                payment_method: PaymentMethodEnum;
                receipt_number: string;
            };
            onClose: onClose;
        }>(),
        "preview migration": props<{
            data: {
                from_academic_year_id?: string;
                to_academic_year_id?: string;
                from_standard_id?: string;
                to_standard_id?: string;
                to_batch_id?: string;
                to_division: string | null;
                admission_ids: string[];
            };
            onSuccess: (response: any) => void;
        }>(),
        "execute migration": props<{
            data: {
                from_academic_year_id?: string;
                to_academic_year_id?: string;
                from_standard_id?: string;
                to_standard_id?: string;
                to_batch_id?: string;
                admission_ids: string[];
            };
            onSuccess: (response: any) => void;
        }>(),
    },
});
